import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['offices', 'agentTeams', 'markets', 'roleType', 'relatable']

  connect() {
    var relatableDiv = this.relatableTarget
    var officeSelect = this.officesTarget
    var agentTeamSelect = this.agentTeamsTarget
    var marketAdminSelect = this.marketsTarget

    officeSelect.classList.remove('hidden')
    agentTeamSelect.classList.remove('hidden')
    marketAdminSelect.classList.remove('hidden')

    this.roleTypeTarget.addEventListener('change', e => {
      if (
        e.target.value === 'Roles::OfficeManager' ||
        e.target.value === 'Roles::Accountant'
      ) {
        relatableDiv.append(officeSelect)
      } else {
        officeSelect.remove()
      }

      var agentTeamSearch = document.getElementById('agent-teams-search-field')
      if (agentTeamSearch) {
        if (
          e.target.value === 'Roles::Agent' ||
          e.target.value === 'Roles::Assistant'
        ) {
          agentTeamSearch.classList.remove('hidden')
        } else {
          agentTeamSearch.classList.add('hidden')
        }
      } else {
        if (
          e.target.value === 'Roles::Agent' ||
          e.target.value === 'Roles::Assistant'
        ) {
          relatableDiv.append(agentTeamSelect)
        } else {
          agentTeamSelect.remove()
        }
      }

      if (e.target.value === 'Roles::MarketAdmin') {
        relatableDiv.append(marketAdminSelect)
      } else {
        marketAdminSelect.remove()
      }
    })

    this.roleTypeTarget.dispatchEvent(new Event('change'))
  }
}
